var base = require('settings/security');

Vue.component('spark-security', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/settings/security.js